import { reactive } from 'vue';

export const applicationState = reactive({
    identifier: null,
    name: null,
    errorMessage: null,
    returnUrl: null,
});

export function setApplication(application) {
    if (!application) {
        applicationState.identifier = null;
        applicationState.name = null;
        return;
    }

    applicationState.identifier = application.identifier;
    applicationState.name = application.name;
}

export function setErrorMessage(errorMessage) {
    applicationState.errorMessage = errorMessage;
}

export function setReturnUrl(returnUrl) {
    applicationState.returnUrl = returnUrl;
}